export enum CollaborativeAreaType {
    PublicArea = 0,
    WorkGroups = 1,
    PrivateArea = 2
}